// import React from "react";
// import Header1 from "../../Components/seperate Components/Header1";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
// import "../../Styles/Redirecting Styles/FooterStyle/Policy.css";
// import Footer from "../../Components/Footer";
// import { Helmet } from "react-helmet";
import React from "react";
import { Modal, Button } from "react-bootstrap";

const Policy = ({ show, handleClose }) => {
 return (
    <Modal show={show} onHide={handleClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title style={{color:"#01536E"}}>Privacy Policy</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
        <h5>Privacy Policy for Ambrella</h5>
        <p>
          At Ambrella, one of our top priorities is the privacy of our
          visitors. This Privacy Policy outlines the types of information
          we collect and record, and how we use it.
        </p>
        <h5>GDPR – Data Protection</h5>
        <p>
          We are the Data Controller of your information. Ambrella will keep
          your personal information only for as long as needed for the purposes
          outlined in this Privacy Policy.
        </p>
        <ul style={{color:"#515151ff"}}>
          <li>The right to access, update, or delete your information</li>
          <li>The right to restrict processing</li>
          <li>The right to data portability</li>
          <li>The right to withdraw consent</li>
        </ul>
        <p>
          By using our website, you agree to our Privacy Policy and accept its terms.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={handleClose}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default Policy;
